import { Tile } from '@/components/ui/Tile';
import { useMe } from '@/hooks/useMe';
import { Bot, Palette, Camera, BookOpen, Settings, GraduationCap, ShieldCheck, CalendarDays, PackageCheck } from 'lucide-react';
import { isStandalone } from '@/lib/tg';

export default function HomePage() {
  const { data: me, isLoading } = useMe();
  const firstName = me?.firstName ?? 'друг';
  const role = me?.role ?? 'intern';

  if (isLoading) {
    return <div className="p-6 text-tg-hint">Загрузка…</div>;
  }

  const isIntern = role === 'intern';
  const isAdmin = role === 'admin';
  const canUseStudios = role === 'admin' || role === 'consultant';

  return (
    <div className="safe-top safe-bottom min-h-full p-4 space-y-4">
      <header className="space-y-1">
        <h1 className="text-2xl font-bold">
          Amrita <span className="text-brand-orange">2.0</span>
        </h1>
        <p className="text-tg-hint text-sm">Привет, {firstName}! 👋</p>
      </header>

      <div className="grid grid-cols-2 gap-3">
        {isIntern && (
          <Tile
            icon={<GraduationCap />}
            title="Обучение"
            subtitle="18 уроков"
            to="/training"
            variant="primary"
            className="col-span-2"
          />
        )}
        {!isIntern && (
          <>
            <Tile
              icon={<GraduationCap />}
              title="Обучение"
              subtitle="Все 18 уроков"
              to="/training"
            />
            <Tile
              icon={<BookOpen />}
              title="Шпаргалка"
              subtitle="Поиск в базе"
              to="/training/search"
            />
            <Tile icon={<CalendarDays />} title="Табель" subtitle="График выходов" to="/shifts" />
            <Tile icon={<PackageCheck />} title="Сроки" subtitle="Контроль товара" to="/expiry" />
          </>
        )}

        <Tile icon={<Bot />} title="ИИ-чат" subtitle="/ai" to="/ai" />

        {/* Студии — только в Mini App (нав-гигиена; backend всё равно гейтит по роли). */}
        {!isStandalone() && (
          <>
            <Tile
              icon={<Palette />}
              title="Контент"
              subtitle={canUseStudios ? 'Комикс · Карусель' : 'Недоступно стажёру'}
              to="/content"
              disabled={!canUseStudios}
            />

            <Tile
              icon={<Camera />}
              title="Фото"
              subtitle={canUseStudios ? 'Портреты · Редактор' : 'Недоступно стажёру'}
              to="/photo"
              disabled={!canUseStudios}
            />
          </>
        )}

        <Tile icon={<Settings />} title="Кабинет" subtitle="Профиль" to="/cabinet" />

        {isAdmin && !isStandalone() && (
          <Tile
            icon={<ShieldCheck />}
            title="Admin"
            subtitle="Управление"
            to="/admin"
            variant="accent"
            className="col-span-2"
          />
        )}
      </div>
    </div>
  );
}
